/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../../../../common";
import type {
  Proxy,
  ProxyInterface,
} from "../../../../contracts/dependant/proxy/Proxy";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "admin",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "delegate",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "activated",
        type: "bool",
      },
    ],
    name: "DelegateSet",
    type: "event",
  },
  {
    stateMutability: "payable",
    type: "fallback",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "_inputs",
        type: "address[]",
      },
    ],
    name: "sysAddDelegates",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "sysCountDelegate",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "_inputs",
        type: "address[]",
      },
    ],
    name: "sysDelDelegates",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "sysGetAdmin",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "sysGetDelegateAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "sysGetDelegateAddresses",
    outputs: [
      {
        internalType: "address[]",
        name: "",
        type: "address[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address",
      },
    ],
    name: "sysGetDelegateIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "sysGetOutOfService",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "sysGetRevertMessage",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "sysGetTransparent",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "_delegatesToDel",
        type: "address[]",
      },
      {
        internalType: "address[]",
        name: "_delegatesToAdd",
        type: "address[]",
      },
    ],
    name: "sysReplaceDelegates",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_input",
        type: "address",
      },
    ],
    name: "sysSetAdmin",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_input",
        type: "uint256",
      },
    ],
    name: "sysSetOutOfService",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_input",
        type: "uint256",
      },
    ],
    name: "sysSetRevertMessage",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_input",
        type: "uint256",
      },
    ],
    name: "sysSetTransparent",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
] as const;

const _bytecode =
  "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";

type ProxyConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: ProxyConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class Proxy__factory extends ContractFactory {
  constructor(...args: ProxyConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    admin: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<Proxy> {
    return super.deploy(admin, overrides || {}) as Promise<Proxy>;
  }
  override getDeployTransaction(
    admin: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(admin, overrides || {});
  }
  override attach(address: string): Proxy {
    return super.attach(address) as Proxy;
  }
  override connect(signer: Signer): Proxy__factory {
    return super.connect(signer) as Proxy__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): ProxyInterface {
    return new utils.Interface(_abi) as ProxyInterface;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): Proxy {
    return new Contract(address, _abi, signerOrProvider) as Proxy;
  }
}
